import React, { useCallback, useEffect, useRef } from 'react';
import {connect,  useDispatch, useSelector } from 'react-redux';
import StageForm from "../StagePage/form";
import { stageActions } from '../../../actions';
import { useParams } from 'react-router-dom';
import { useDetectOutsideClick } from '../../../utils/useDetectOutsideClick';
import { useSafePosition } from '../../../utils/useSafePosition';

function NewStage({
  handleCloseNewForm, 
  fromKanban, 
  can_access_approval_request
}) {
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(formRef, false);
  let { workspace_id } = useParams();

  const stage_error = useSelector(state => state.stage);
  const { isNewStageModalOpen, boundary } = useSelector(state => state.new_stage_popup);
  const position = useSafePosition({
    initialTop: boundary.top,
    initialLeft: boundary.left,
    sourceWidth: boundary.width,
    sourceHeight: boundary.height,
    offsetTop: -8,
    width: formRef.current ? formRef.current.offsetWidth : 0,
    height: formRef.current ? formRef.current.offsetHeight : 0
  });

  const showResults = (values) => {
    dispatch(stageActions.createStage(values, workspace_id, handleCloseNewForm, fromKanban));
  }

  useEffect(() => {
    if(isNewStageModalOpen) {
      setIsActive(true);
    }
  }, [isNewStageModalOpen]);

  useEffect(() => {
    if(!isActive) {
      handleCloseNewForm();
    }
  }, [isActive]);



  if (isNewStageModalOpen === false) {
    return null;
  }

  return (
    <StageForm onSubmit={showResults}
      request_approval={can_access_approval_request}
      goupId={workspace_id}
      newForm="newForm"
      stage_error={stage_error && stage_error}
      handleCloseForm={handleCloseNewForm}
      style={position}
      formRef={formRef}
      className="new-stage-form bg-white rounded-corners box-shadow p-2"
    />
  );
}

const mapStateToProps = (state) => {
  return {
    loading: state.stage.loading
  };
};

export default connect(mapStateToProps, { stageActions })(NewStage);
